<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>THE CAVE</span></p>
<p class="part-left1"><i>And they do not know the future mystery,</i></p>
<p class="part-left2"><i>or understand ancient matters</i>.</p>
<p class="part-left2"><i>And they do not know what is going to happen to them</i>,</p>
<p class="part-left2"><i>and they will not save their souls from the future mystery</i>.</p>
<p class="part-left2a">—<i>The Dead Sea Scrolls</i>, prophecy of the Essenes</p>
<p class="part-left2"><i>Now has come the last age of the song of Cumae</i>.</p>
<p class="part-left2"><i>From the renewed spirit of the Ages a new Order is born</i>.</p>
<p class="part-left2"><i>Now the Virgin returns, the reign of Saturn returns</i>.</p>
<p class="part-left2"><i>Now a new generation is sent down from heaven on high</i>.</p>
<p class="part-left2a">—<i>Virgil, Fourth Eclogue</i>, messianic prophecy of the Sibyl</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?7ae60ff2